<template>
  <b-overlay
    :show="loader"
    opacity="0.50"
    rounded="sm"
  >
    <div>
      <section>
        <b-row>
          <b-col
            cols="12"
            class="d-flex justify-content-center"
          >
            <b-card class="w-100 p-0">
              <b-card-text>

                <b-list-group class="agenda-list">

                  <b-list-group-item
                    v-for="(agenda, aIndex) in fetchData"
                    :key="aIndex"
                    class="agenda-item mb-3"
                  >
                    <!-- Periodo -->
                    <h5 class="agenda-periodo">
                      {{ agenda.clave }}
                    </h5>

                    <!-- Cursos -->
                    <b-list-group class="border-0">
                      <b-list-group-item
                        v-for="(curso, cIndex) in agenda.cursos"
                        :key="cIndex"
                        class="curso-item"
                      >
                        <!-- Curso -->
                        <div class="curso-header">
                          <feather-icon
                            icon="BookOpenIcon"
                            class="mr-1"
                          />
                          {{ curso.materia }}
                        </div>

                        <div class="curso-modalidad">
                          Modalidad: <strong>{{ curso.modalidad }}</strong>
                        </div>

                        <!-- Recursos -->
                        <b-list-group class="mt-2 recursos-list">
                          <b-list-group-item
                            v-for="(recurso, rIndex) in curso.recursos"
                            :key="rIndex"
                            class="recurso-item"
                          >
                            <div class="recurso-row">
                              <feather-icon
                                icon="HexagonIcon"
                                class="text-primary"
                              />
                              {{ recurso.nombre }}
                            </div>
                            <div class="recurso-row">
                              <feather-icon
                                icon="CalendarIcon"
                                class="text-warning"
                              />
                              {{ recurso.fecha || 'Pendiente' }}
                            </div>
                            <div class="recurso-row">
                              <feather-icon
                                icon="WatchIcon"
                                class="text-info"
                              />
                              {{ recurso.horaIni || recurso.horaFin ? `${recurso.horaIni} - ${recurso.horaFin}` : 'Pendiente' }}

                            </div>
                            <div class="recurso-row">
                              <feather-icon
                                icon="MapPinIcon"
                                class="text-danger"
                              />
                              {{ recurso.lugar || 'Pendiente' }}
                            </div>
                            <div class="recurso-row">
                              <feather-icon
                                icon="MessageCircleIcon"
                              />
                              {{ recurso.comentarios || '' }}
                            </div>
                          </b-list-group-item>
                        </b-list-group>

                      </b-list-group-item>
                    </b-list-group>

                  </b-list-group-item>

                </b-list-group>

              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </section>
    </div>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText,
  BOverlay, BListGroupItem, BListGroup,
} from 'bootstrap-vue'
import {
  onMounted, ref,
} from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getData } from '@core/utils/http/general'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BOverlay,
    BListGroupItem,
    BListGroup,
  },
  setup() {
    const loader = ref(false)
    const fetchData = ref([])
    const toast = useToast()
    const getDatos = () => {
      loader.value = true
      getData({ action: 26, token: store.state.cuenta.session.token }, 'wsalumno')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) fetchData.value = response.data.data
          else {
            toast({
              component: ToastificationContent,
              props: {
                title: `${response.data.status} - Sección en construcción`,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
          loader.value = false
        }).catch(err => {
          loader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error, No hay conexión',
              text: err,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    onMounted(() => {
      getDatos()
    })
    return {
      // loader
      fetchData,
      loader,
    }
  },
}
</script>

<style scoped>
/* Periodo */
.agenda-item {
  background: #f8f9fb;
  border-radius: 10px;
  border: none;
}

.agenda-periodo {
  color: #008351;
  font-weight: 600;
  margin-bottom: 1rem;
}

/* Curso */
.curso-item {
  background: transparent;
  border: none !important;
  padding: 0.75rem 0;
}

.curso-header {
  font-weight: 600;
  font-size: 1rem;
  color: #1f2937;
}

.curso-modalidad {
  font-size: 0.9rem;
  color: #6b7280;
}

/* Recursos */
.recursos-list {
  border-left: 3px solid #e5e7eb;
  margin-left: 0.5rem;
}

.recurso-item {
  border: none;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  padding: 0.75rem;
}

.recurso-row {
  font-size: 0.85rem;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

  </style>
